/*
 * @Author: Dom
 * @Date: 2022-05-18 18:14:55
 * @LastEditTime: 2022-08-03 15:01:09
 * @LastEditors: Dom
 * @FilePath: \seller-web\src\views\personal\authent\component\personal\locales\zh-TW.ts
 */
export default {
    'page.personal.center.compontent.person.message' : '個人信息',
    'page.personal.center.compontent.person.nationality':'國籍',
    'page.personal.center.compontent.person.name':'姓名',
    'page.personal.center.compontent.person.EnName':'英文姓名',
    'page.personal.center.compontent.person.email':'郵箱',
    'page.personal.center.compontent.person.phone':'聯系電話',
    'page.personal.center.compontent.person.address':'聯系地址',
    'page.personal.center.compontent.person.addressMod':'詳細地址',
    'page.personal.center.compontent.person.select':'請選擇',
    'page.personal.center.compontent.person.type':'證件類型',
    'page.personal.center.compontent.person.number':'證件號碼',
    'page.personal.center.compontent.person.id':'身份證',
    'page.personal.center.compontent.person.passport':'護照',
    'page.personal.center.compontent.person.certificateTypes':'通行證',
    'page.personal.center.compontent.person.certificateValidity':'證件有效期',
    'page.personal.center.compontent.person.effective':'是否長期有效',
    'page.personal.center.compontent.person.certificate':'證件正面',
    'page.personal.center.compontent.person.reverseCertificate':'證件反面',
    'page.personal.center.compontent.person.upload':'請上傳清晰可見的證件照反面',
    'page.personal.center.compontent.person.size':'文件大小不超過10M',
    'page.personal.center.compontent.person.support':'文件格式支持',
    'page.personal.center.compontent.person.certificatez':'請上傳清晰可見的證件照正面',
    'page.personal.center.compontent.person.submit':'提交',
    'page.personal.center.compontent.person.reset':'重置',
}
